import { render, staticRenderFns } from "./openClueDialog.vue?vue&type=template&id=6e2570fd"
import script from "./openClueDialog.vue?vue&type=script&lang=js"
export * from "./openClueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports